
import React from 'react';
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { useGoogleReviews } from "@/hooks/useGoogleReviews";
import { ReviewStars } from './ReviewStars';
import { ReviewCard } from './ReviewCard';

interface GoogleReviewsSectionProps {
  consultorioId: "paulista" | "mogi" | "suzano";
}

export const GoogleReviewsSection: React.FC<GoogleReviewsSectionProps> = ({ consultorioId }) => {
  const { reviews, loading, error } = useGoogleReviews(consultorioId, 3);

  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-32 mb-3"></div>
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-20 bg-gray-100 rounded-lg"></div>
          ))}
        </div>
      </div>
    );
  }

  if (error || reviews.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-gray-500 text-sm">
          {error ? 'Erro ao carregar avaliações' : 'Nenhuma avaliação encontrada'}
        </p>
      </div>
    );
  }

  const averageRating = reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold font-accent text-gray-800 flex items-center gap-2">
          <Star className="w-5 h-5 text-yellow-500 fill-current" />
          Avaliações Google
        </h3>
        <div className="flex items-center gap-2">
          <ReviewStars rating={averageRating} />
          <span className="text-xs text-gray-500">({reviews.length} avaliações)</span>
        </div>
      </div>
      
      <div className="space-y-3">
        {reviews.slice(0, 2).map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
      
      {reviews.length > 2 && (
        <div className="mt-3 text-center">
          <Button
            variant="outline"
            size="sm"
            className="text-brand-primary border-brand-primary/20 hover:bg-brand-primary/5"
            onClick={() => window.open(`https://search.google.com/local/reviews?placeid=${reviews[0].placeId}`, '_blank')}
          >
            Ver todas as avaliações
          </Button>
        </div>
      )}
    </div>
  );
};
